import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { useNavigation } from 'react-day-picker';
import { YearMonth } from '@medable/i18n-core';
import { LocaleContext } from '../../../../i18n/src';
import { Icon } from '../../../../icon/src';
import { H5 } from '../../../../typography/src';
import { CalendarNavButton } from './calendar_nav_button';
import { toDate, toPlainDate, toZonedDateTime } from '../date_utils';
export const CalendarNav = (props) => {
    var _a, _b;
    const _c = useNavigation(), { 
    /** The month to display in the calendar. When `numberOfMonths` is greater than one, is the first of the displayed months. */
    currentMonth, 
    /** Navigate to the specified month. */
    goToMonth, 
    /** The months displayed in the calendar, used to determine the # of months to navigate to */
    displayMonths } = _c, navProps = __rest(_c, ["currentMonth", "goToMonth", "displayMonths"]);
    const isPreviousMonthDisabled = navProps.previousMonth === undefined;
    const isNextMonthDisabled = navProps.nextMonth === undefined;
    const locale = useContext(LocaleContext).toString();
    // Number of months to skip when navigating using the previous / next buttons
    const numberOfMonths = displayMonths.length;
    // We calculate the previous / next dates here, as the react-day-picker ones are undefined
    // when the month is out of the `fromDate` / `toDate` range.
    // However, we still want to show the nav buttons with proper aria labels
    const previousMonth = (_a = toPlainDate(currentMonth)) === null || _a === void 0 ? void 0 : _a.add({
        months: numberOfMonths * -1,
    });
    const nextMonth = (_b = toPlainDate(currentMonth)) === null || _b === void 0 ? void 0 : _b.add({
        months: numberOfMonths,
    });
    return (_jsxs("nav", { id: props.id, className: 'nucleus-flex nucleus-flex-row nucleus-items-center nucleus-gap-2 nucleus-p-2', children: [_jsx(H5, { children: new YearMonth(locale).format(toZonedDateTime(toPlainDate(currentMonth))) }), _jsxs("div", { className: 'nucleus-flex nucleus-grow nucleus-flex-row nucleus-justify-end nucleus-gap-2', children: [_jsx(CalendarNavButton, { "aria-label": new YearMonth(locale).format(toZonedDateTime(previousMonth)), disabled: isPreviousMonthDisabled, onClick: previousMonth ? () => goToMonth(toDate(previousMonth)) : undefined, children: _jsx(Icon, { name: 'chevronLeft', color: 'current' }) }), _jsx(CalendarNavButton, { "aria-label": new YearMonth(locale).format(toZonedDateTime(nextMonth)), disabled: isNextMonthDisabled, onClick: nextMonth ? () => goToMonth(toDate(nextMonth)) : undefined, children: _jsx(Icon, { name: 'chevronRight', color: 'current', size: 'base' }) })] })] }));
};
//# sourceMappingURL=calendar_nav.js.map